module.exports = __webpack_public_path__ + "static/media/va.f8836bee.svg";